import { Button } from 'components/buttons/Button'
import { useTranslation } from 'react-i18next'
import { useTimeCardsContext } from '@features/time-logging/providers/TimeCardsContextProvider'

export const SubmitButton = () => {
  const { t } = useTranslation()
  const { submitAll, isLoading, atLeastOneTimeCardSubmittable, isUpdating } =
    useTimeCardsContext()

  return (
    <Button
      className="text-sm"
      onClick={() => submitAll()}
      disabled={isLoading || !atLeastOneTimeCardSubmittable || isUpdating}
      tooltip={
        atLeastOneTimeCardSubmittable &&
        t('features.timeLogging.submitAllOpenAndValidTimeCards')
      }
      tooltipProps={{ place: 'bottom' }}
    >
      {t('features.timeLogging.submitAll')}
    </Button>
  )
}
